export function initStoresMap() {
  initSlideStores()
  const countryBlockTriggers = [
    ...document.querySelectorAll('.c-map__country-title'),
  ]
  const locationAndMarkerCollection = []
  const locations = [...document.querySelectorAll('.c-map__single-store')].map(
    li => {
      const data = {
        icon: li.dataset.icon,
        lat: li.dataset.lat,
        lng: li.dataset.lng,
        country: li.dataset.country,
        element: li,
      }
      return data
    },
  )

  const bounds = new google.maps.LatLngBounds()
  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: 8,
    center: new google.maps.LatLng(59.2323, 24.234234),
    styles: [
      {
        featureType: 'all',
        elementType: 'labels.text.fill',
        stylers: [
          {
            saturation: 36,
          },
          {
            color: '#333333',
          },
          {
            lightness: 40,
          },
        ],
      },
      {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            visibility: 'on',
          },
          {
            color: '#ffffff',
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: 'all',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#fefefe',
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#fefefe',
          },
          {
            lightness: 17,
          },
          {
            weight: 1.2,
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#e9eaf0',
          },
        ],
      },
      {
        featureType: 'landscape.man_made',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#bec0d3',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            color: '#dedede',
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#dfe1ee',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 29,
          },
          {
            weight: 0.2,
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 18,
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f2f2f2',
          },
          {
            lightness: 19,
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e9e9e9',
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#bec0d3',
          },
        ],
      },
    ],
  })

  locations.forEach(location => {
    const position = new google.maps.LatLng(location.lat, location.lng)
    const marker = new google.maps.Marker({
      position,
      map,
      icon: location.icon,
      optimized: false,
      customPropertyCountry: location.country,
      scaledSize: new google.maps.Size(30, 34),
    })
    bounds.extend(position)
    const locationAndMarkerObject = {
      element: location.element,
      marker,
    }
    locationAndMarkerCollection.push(locationAndMarkerObject)
    marker.addListener('click', () => {
      map.setCenter(marker.getPosition())
      map.setZoom(12)
      countryBlockTriggers.forEach(country => {
        if (country.dataset.country == marker.customPropertyCountry) {
          if (!country.classList.contains('active-country')) {
            country.click()
          }
        }
      })
    })
  })
  map.fitBounds(bounds)

  locationAndMarkerCollection.forEach(object => {
    object.element.addEventListener('click', e => {
      locationAndMarkerCollection.forEach(objectInForEach => {
        if (object.marker == objectInForEach.marker) {
          map.setCenter(objectInForEach.marker.getPosition())
          map.setZoom(12)
        }
      })
    })
  })
}

function slide(target, slideIn) {
  if (slideIn) {
    target.style.height = 'auto'
    const height = `${target.clientHeight}px`
    target.style.height = '0px'
    setTimeout(() => {
      target.style.height = height
    }, 0)
  } else {
    target.style.height = '0px'
  }
}

function initSlideStores() {
  const countries = [...document.querySelectorAll('.c-map__country-title')]
  countries.forEach(country => {
    country.addEventListener('click', e => {
      e.preventDefault()

      const wasOpen = country.classList.contains('active-country')
      // close all tabs
      countries.forEach(countryToBeClosed => {
        countryToBeClosed.classList.remove('active-country')
        slide(countryToBeClosed.nextElementSibling, false)
      })

      // If was open, leave it closed
      if (!wasOpen) {
        country.classList.add('active-country')
        slide(country.nextElementSibling, true)
      }
      // if (!country.classList.contains('active-country')) {
      //   countries.forEach((countryToBeClosed) => {
      //     countryToBeClosed.classList.remove('active-country')
      //     slide(countryToBeClosed.nextElementSibling, false)
      //   })
      //   country.classList.add('active-country')
      //   const target = country.nextElementSibling
      //   if (country.classList.contains('active-country')) {
      //     slide(target, true)
      //   } else {
      //     slide(target, false)
      //   }
      // }
    })
  })
}

export function initProjectsMap() {
  const projects = [...document.querySelectorAll('.js-project-info')].map(
    li => {
      const data = {
        title: li.dataset.title,
        photo: li.dataset.photo,
        lat: li.dataset.lat,
        lng: li.dataset.lng,
        marker: li.textContent,
      }
      return data
    },
  )

  const createContentString = (
    title,
    content,
    photo,
  ) => `<div class="map-marker">
      <img src="${photo}">
      <h3 class="map-title">${title}</h3>
      <p class="map-copy">${content}</p>
      </div>`
  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: 12,
    // center: new google.maps.LatLng(59.2323, 24.234234),
    center: new google.maps.LatLng(49.38748, 14.833289),
    styles: [
      {
        featureType: 'all',
        elementType: 'labels.text.fill',
        stylers: [
          {
            saturation: 36,
          },
          {
            color: '#333333',
          },
          {
            lightness: 40,
          },
        ],
      },
      {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            visibility: 'on',
          },
          {
            color: '#ffffff',
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: 'all',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#fefefe',
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#fefefe',
          },
          {
            lightness: 17,
          },
          {
            weight: 1.2,
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#e9eaf0',
          },
        ],
      },
      {
        featureType: 'landscape.man_made',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#bec0d3',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            color: '#dedede',
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#dfe1ee',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 29,
          },
          {
            weight: 0.2,
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 18,
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f2f2f2',
          },
          {
            lightness: 19,
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e9e9e9',
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#bec0d3',
          },
        ],
      },
    ],
  })

  const bounds = new google.maps.LatLngBounds()

  let prevInfowindow = false

  projects.forEach(location => {
    const position = new google.maps.LatLng(location.lat, location.lng)
    const marker = new google.maps.Marker({
      position,
      map,
      icon: `${wordpress_localized_variables.theme_url}/dist/img/about_marker.png`,
    })

    const infowindow = new google.maps.InfoWindow({
      content: `<div class="c-infowindow">
      <img src=${location.photo}><h3 class="map-title">${location.title}</h3></div>`,
    })

    marker.addListener('click', () => {
      if (prevInfowindow) {
        prevInfowindow.close()
      }

      prevInfowindow = infowindow

      infowindow.open(map, marker)
    })
    bounds.extend(position)
  })
  // map.fitBounds(bounds)
  // map.setZoom(4)

  if (window.innerWidth < 600) {
    map.setZoom(3)
  } else {
    map.setZoom(4)
  }
}
